import { SkeletonOfAnySize } from 'src/components/Skeletons';
import { QrImage } from './components/QrImage';
import { DepositCryptoOption } from 'react-easyrocket';

interface QrCodeProps {
  selectedMethod: DepositCryptoOption | undefined;
  isLoading: boolean;
  account: string;
}

export const QrCode = ({ selectedMethod, isLoading, account }: QrCodeProps) => {
  if (isLoading) {
    return (
      <SkeletonOfAnySize className="w-[120px] bg-gg_bg max-w-[120px] min-w-[120px] h-[120px] min-h-[120px] mr-2 rounded object-contain flex" />
    );
  }

  if (!selectedMethod) {
    return (
      <div className="w-[120px] flex items-center justify-center text-center font-semibold text-xl uppercase mr-2 rounded object-contain h-[120px] bg-[white]">
        <p>
          Select <br /> Coin
        </p>
      </div>
    );
  }

  if (!account) {
    return (
      <div className="w-[120px] flex items-center justify-center text-center font-semibold text-xl uppercase mr-2 rounded object-contain h-[120px] bg-[white]">
        <p>
          No <br />
          Payment
          <br />
          Address
        </p>
      </div>
    );
  }

  return (
    <div className="w-[120px] mr-2 h-[120px] min-w-[120px]">
      <QrImage
        key={account}
        dataForQRCode={account}
        className="!w-[120px] h-full rounded object-contain"
      />
    </div>
  );
};
